import Vaporeon from './Vaporeon';

export default Vaporeon;



/** WEBPACK FOOTER **
 ** ./source/134-vaporeon/index.js
 **/